import { BtnSesame } from '../display/BtnSesame';

const HudConfig = {
  defaultButton: BtnSesame,
  buttons: [
    {
      id: 'btn_home',
      costume: 'btn_home',
      sheet: 'buttons',
      buttongroup: 'topleft',
      event: 'RETURN_HOME',
      vo: { sheet: 'ui_vo', id: 'ui_home' },
      clickSFX: { sprite: 'sfx', id: 'sfx_ui_btn' },
    },
    {
      id: 'btn_start',
      costume: 'btn_start',
      sheet: 'buttons',
      buttongroup: 'landing',
      event: 'ENTER_GAME',
      vo: { sheet: 'ui_vo', id: 'ui_play' },
      clickSFX: { sprite: 'sfx', id: 'sfx_ui_btn' },
    },
    {
      id: 'btn_close',
      costume: 'btn_close',
      sheet: 'buttons',
      vo: { sheet: 'ui_vo', id: 'ui_close' },
      clickSFX: { sprite: 'sfx', id: 'sfx_ui_btn' },
    },
  ],
  states: {
    EMPTY: {
      buttons: [],
    },
    DEFAULT: {
      buttons: ['btn_home'],
    },
    LANDING: {
      buttons: ['btn_start'],
    },
  },
  buttongroups: {
    landing: {
      anchor_group: { x: 0.5, y: 1 },
      anchor_screen: { x: 0.5, y: 1 },
      align_buttons: 'center',
    },
  },
};

export { HudConfig };
